
import { Base } from "../core/base.model";
import { Tickets } from "./tickets.model";
import { TicketAprobadoPerfil, TicketEsquemaPerfil, TicketNivelPerfil } from "src/app/utilerias/enums/ticket-perfil.enum";

export class TicketPerfil extends Base{
    idTicketPerfil: number;
    ticket: Tickets;
    tipoContratacion: String;
    lugarTrabajo: String;
    idCliente: String;
    nombreCliente: String;
    ubicacionCliente: String;
    perfil: String;
    nivelPerfil: TicketNivelPerfil;
    numPerfiles: number;
    tipoProyecto: String;
    fechaInicio: Date;
    fechaFin: Date;
    horario: String;
    tarifa: String;
    sueldoOferta: String;
    esquemaSueldo: TicketEsquemaPerfil;
    aprobadoPor: TicketAprobadoPerfil;
    conocimientoDeseable: String;
    experiencia: number;
    consideraciones: String;
    equipoRequerido: String;
    recursoDisponible: boolean;
    ingles: number;

}